$(document).on('logged-in', function(event,passport){

  if( !!_ppprotect.length) {

      var prepop = '&first='+passport.firstname+'&last='+passport.lastname+'&email='+passport.email;
      var prepop2 = '?first='+passport.firstname+'&last='+passport.lastname+'&email='+passport.email;

      var privhtml = $('.pcontent').html();

      //$('.pcontent').remove();

      //_ppprotect.fadeTo(300,0);
      setTimeout(function(){

        _ppprotect.html(privhtml);

        if(passport) {
          var iframe = $('iframe.euticket');
          var iframeurl = $('iframe.euticket').attr('src');
          iframeurl = iframeurl + prepop; 
          iframe.attr('src', iframeurl);



          var mxbtn = $('.mxticketlink');
          var mxbtnurl = $('.mxticketlink').attr('href');
          mxbtnurl = mxbtnurl + prepop2;
          mxbtn.attr('href', mxbtnurl);

        }

        _ppprotect.fadeTo(300,1);
      },350);

      window.oncontextmenu = function () {
          //return false;
      }

  }

});